module.exports = __webpack_public_path__ + "9d15636f64435ee987d093983a721787.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-20.png
// module id = 3180
// module chunks = 0